export const DEFAULT_DURATION = 5000
export const EXIT_ANIMATION_DURATION = 400
// Note: more toasts than this push the oldest out
export const MAX_VISIBLE_TOASTS = 5
